export const isEqualByIds = <T extends { id: string }>(a?: T[], b?: T[]) => {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  return a.every((item) => b.some((bItem) => bItem.id === item.id));
};
